export default __webpack_public_path__ + "static/media/illusion.673a5afb.svg";